import { createReducer, on } from '@ngrx/store';

import * as Sentry from '@sentry/angular';

import { initialUserState } from './user.state';
import {
  resetPermissions,
  resetSettings,
  resetUser,
  setUserId,
  setPermissions,
  setSettings,
  setUser,
} from './user.actions';

import _ from 'lodash';

import { Utility } from 'src/services/utility.service';

import { User } from 'src/models/User';
import { Settings } from 'src/models/Settings';
import { Permissions } from 'src/models/Permissions';

export const userReducer = createReducer(
  initialUserState,

  on(setUserId, (state, action) => {
    const userId: number | undefined = action.userId;
    Utility.setStore('userId', userId, true);

    return {
      ...state,
      userId: userId,
    };
  }),

  on(setUser, (state, action) => {
    const user: User = action.user;
    Utility.setStore('user', user, true);

    Sentry.setUser({
      id: user.id,
      username: `${user.firstName} ${user.lastName}`.trim(),
    });

    //#region Disabling Replays for User Sebastian Linecker (because otherwise random replays without errors are being recorded somehow)
    const sebastianLineckerUserId = 8751;
    const isReplayOptOutUser = user.id === sebastianLineckerUserId;

    if (isReplayOptOutUser) {
      try {
        Sentry.getReplay()?.stop();
      } catch {}
    }
    //#endregion

    const userId: number = user.id;
    Utility.setStore('userId', userId, true);

    return {
      ...state,
      userId: userId,
      user,
    };
  }),

  on(resetUser, (state) => {
    Utility.removeStore('user');

    Sentry.setUser(null);

    return {
      ...state,
      user: undefined,
    };
  }),

  on(setSettings, (state, action) => {
    const settings: Settings = _.cloneDeep(action.settings);
    Utility.setStore('settings', settings, true);

    return {
      ...state,
      settings,
    };
  }),

  on(resetSettings, (state) => {
    Utility.removeStore('settings');

    return {
      ...state,
      settings: undefined,
    };
  }),

  on(setPermissions, (state, action) => {
    const permissions: Permissions = action.permissions;
    Utility.setStore('permissions', permissions, true);

    return {
      ...state,
      permissions,
    };
  }),

  on(resetPermissions, (state) => {
    Utility.removeStore('permissions');

    return {
      ...state,
      permissions: undefined,
    };
  })
);
